import { render } from "./specsremove.vue?vue&type=template&id=f9cd768e"
import script from "./specsremove.vue?vue&type=script&lang=js"
export * from "./specsremove.vue?vue&type=script&lang=js"

import "./specsremove.vue?vue&type=style&index=0&id=f9cd768e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__